// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item[data-v-cadee558] {\n  position: relative;\n  padding-top: 0px;\n  display: inline-block;\n}\n.notify-badge[data-v-cadee558] {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  text-align: center;\n  border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
